import Nutritionix from './nutritionix'

export default Nutritionix
